import { useOfferingId } from "hooks/firestore/advanced/useOfferingId"
import { useStorefrontId } from "hooks/firestore/advanced/useStorefrontId"
import { getDocument, useDocument } from "hooks/firestore/core/useDocument"
import { getProductGroupRef } from "hooks/firestore/getRefs"

// ts-prune-ignore-next
export function useProductGroup(
  productGroupId: string | undefined,
  storefrontId?: string,
  offeringId?: string,
  userId?: string
) {
  // TypeScript function overloads should prevent conditional calling of the hook
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const realOfferingId = offeringId || useOfferingId()
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const realStorefrontId = storefrontId || useStorefrontId()
  const { document } = useDocument(getProductGroupRef(realOfferingId, realStorefrontId, productGroupId))

  if (document && userId) {
    document.items.forEach(item => {
      item.visible = item.userVisible?.[userId] ?? item.visible
      item.priceInfo.price = item.priceInfo.userPrice?.[userId] ?? item.priceInfo.price
    })
  }
  return document
}

// ts-prune-ignore-next
export async function getProductGroup(
  productGroupId: string,
  storefrontId: string,
  offeringId: string,
  userId?: string
) {
  const doc = await getDocument(getProductGroupRef(offeringId, storefrontId, productGroupId))

  if (doc && userId) {
    doc.items.forEach(item => {
      item.visible = item.userVisible?.[userId] ?? item.visible
      item.priceInfo.price = item.priceInfo.userPrice?.[userId] ?? item.priceInfo.price
    })
  }
  return doc
}
